import Index from './Index'
import UsersRoutes from './users/routes'

export default [
  {
    path: '/configuration',
    name: 'configuration',
    component: Index,
    meta: {
      auth: true,
      bodyClass: 'navbar-top',
      breadcrumb: 'Configuration'
    },
    children: [
    ]
  },
  ...UsersRoutes
]
